<template>
  <div
    class="drag-outer"
    ref="dragWrap"
    :style="'width:' + imgWidth"
    @mouseenter="isHover = true"
    @mouseleave="isHover = isMousedown = false"
    @mousemove="dragMousemove"
  >
    <div
      class="drag-inner"
      ref="dragElement"
      @mousedown="dragMousedown"
      @mouseup.stop="isMousedown = false"
      @mousewheel="handleScroll"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "incImgSvg",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    imgWidth: {
      type: String,
      default: "400px",
    },
    scaleZoom: {
      type: Object,
      default() {
        return {
          max: 5,
          min: 0.2,
        };
      },
    },
    imgSrc: { // 新增 imgSrc prop
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMousedown: false,
      isHover: false,
      moveStart: {},
      translate: { x: 0, y: 0 },
      scale: 1,
    };
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.resetTransform();
      }
    },
    imgSrc(val) { // 监视 imgSrc 的变化
      this.resetTransform();
    }
  },
  methods: {
    resetTransform() {
      this.scale = 1;
      this.translate = { x: 0, y: 0 };
      this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`;
    },
    handleScroll(e) {
      if (this.isHover) {
        let speed = e.wheelDelta / 120;
        if (e.wheelDelta > 0 && this.scale < this.scaleZoom.max) {
          this.scale += 0.2 * speed;
          if (this.scale > this.scaleZoom.max) {
            this.scale = this.scaleZoom.max;
          }
          this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`;
        } else if (e.wheelDelta < 0 && this.scale > this.scaleZoom.min) {
          this.scale += 0.2 * speed;
          if (this.scale < this.scaleZoom.min) {
            this.scale = this.scaleZoom.min;
          }
          this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`;
        }
        e.preventDefault(); //防止图片搜索时父容器滚动条滚动
      }
    },
  
    dragMousedown(event) { // 添加 event 参数
      this.moveStart.x = event.clientX;
      this.moveStart.y = event.clientY;
      this.isMousedown = true;
    },
    dragMousemove(event) { // 添加 event 参数
      if (this.isMousedown) {
        this.translate.x += (event.clientX - this.moveStart.x) / this.scale;
        this.translate.y += (event.clientY - this.moveStart.y) / this.scale;
        this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`;
        this.moveStart.x = event.clientX;
        this.moveStart.y = event.clientY;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.drag-outer {
  overflow: hidden;
  height: 360px;
  float: left;
  display: flex;
  background-color: #fff;
  justify-content: center;
  align-items: center;

  .drag-inner {
    transform-origin: center center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: move;
    user-select: none;
    width: 100%;
    height: 100%;

    > * {
      -webkit-user-drag: none;
      user-drag: none;
    }

    img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
